<div class="chart">
  <canvas baseChart
          [data]="chartData"
          [type]="'line'"
          [options]="chartOptions"></canvas>
</div>
